import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { useEffect, useState } from "react";
import { ActivityIndicator, Text, TouchableOpacity, View } from "react-native";
import InputDefault from "../../components/Form/InputDefault";
import { FormattedMessage } from "react-intl";
import { If, Then, Else } from "react-if";
import MaskedInputDefault from "../../components/Form/MaskedInputDefault";
import api from "../../services/api";
import { toast } from "../../utils/toast";
import styles from "./styles";
import HeaderTabs from "../../components/HeaderTabs";
import GoBackButton from "../../components/GoBackButton";

const EditCard = ({ route, navigation }) => {
  const [name, setName] = useState("");
  const [numberCard, setNumberCard] = useState("");
  const [validity, setValidity] = useState("");
  const { item } = route.params;
  const [isLoading, setIsLoading] = useState(false);
  // const [cvv, setCvv] = useState('');

  useEffect(() => {
    setName(item.name);
    setNumberCard(item.number);
    setValidity(item.validity);
  }, []);

  async function updateCard() {
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    if (!name) {
      toast(intl.formatMessage({ id: "editCard.preencheNome" }), "#DA1414");
      return false;
    }

    if (!numberCard) {
      toast(intl.formatMessage({ id: "editCard.preencheNome" }), "#DA1414");
      return false;
    }

    if (!validity) {
      toast(
        intl.formatMessage({ id: "editCard.preencheValidadeCartao" }),
        "#DA1414"
      );
      return false;
    }

    setIsLoading(true);
    const data = {
      name: name,
      card_number: numberCard,
      expiration_date: validity,
    };

    api
      .put(`/cards/${item.id}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        navigation.navigate("MyCards");
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        toast(
          intl.formatMessage({ id: "editCard.erroCarregaDados" }),
          "#DA1414"
        );
        setIsLoading(false);
      });
  }

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="editCard.headerEditaCartao" />}
      />

      <View style={styles.container}>
        <FormattedMessage id="editCard.placeholderNomeCompleto">
          {(placeholder) => (
            <InputDefault
              value={name}
              onValueChange={(value) => setName(value)}
              placeholder={placeholder}
            />
          )}
        </FormattedMessage>

        <FormattedMessage id="editCard.placeholderNumCartao">
          {(placeholder) => (
            <MaskedInputDefault
              mask="9999 9999 9999 9999"
              keyboardType="numeric"
              value={numberCard}
              onValueChange={(value) => setNumberCard(value)}
              placeholder={placeholder}
            />
          )}
        </FormattedMessage>

        <FormattedMessage id="editCard.placeholderValidade">
          {(placeholder) => (
            <MaskedInputDefault
              mask="99/99"
              keyboardType="numeric"
              value={validity}
              onValueChange={(value) => setValidity(value)}
              placeholder={placeholder}
            />
          )}
        </FormattedMessage>

        {/* <InputDefault
                    value={cvv}
                    onValueChange={(value) => setCvv(value)}
                    placeholder={"CVV"}
                /> */}

        <View>
          <TouchableOpacity
            disabled={isLoading ? true : false}
            onPress={updateCard}
            style={styles.contentBtn}
          >
            <If condition={isLoading}>
              <Then>
                <ActivityIndicator color="#2797A2" size="small" />
              </Then>
              <Else>
                <Text style={styles.textBtn}>
                  <FormattedMessage id="editCard.btnSalvar" />
                </Text>
              </Else>
            </If>
          </TouchableOpacity>
        </View>

        <View>
          <TouchableOpacity
            style={styles.contentBtnDelete}
            onPress={() => navigation.navigate("DeleteCard", { item })}
          >
            <Text style={styles.textBtnDelete}>
              <FormattedMessage id="editCard.btnExcluirCartao" />
            </Text>
          </TouchableOpacity>
        </View>
      </View>

      <GoBackButton style={{ marginTop: 20 }} />
    </>
  );
};

export default EditCard;
